module.exports = __webpack_public_path__ + "static/media/bg-footer-mobile.5c85b036.png";